import { FC } from 'react'
import { Country } from 'api/countries/getCountriesList'
import { CountryCodeSelectorDropDown } from './CountryCodeSelectorDropDown/CountryCodeSelectorDropDown'
import { useFetchCountryList } from './useFetchCountryList'

import { componentResolver, FetchHookLifecycle } from './Fetch'
import { CountryCodeSelectorLoader } from './CountryCodeSelectorLoader/CountryCodeSelectorLoader'

interface Props {
  onCountrySelected: (country: Country) => void
}

// We render empty if we fail to fetch the country list.

export const CountryCodeSelector: FC<Props> = ({ onCountrySelected }) => {
  return componentResolver(useFetchCountryList(), {
    [FetchHookLifecycle.ERROR]: () => null,
    [FetchHookLifecycle.LOADING]: () => <CountryCodeSelectorLoader />,
    [FetchHookLifecycle.SUCCESS]: ({ data }) => (
      <CountryCodeSelectorDropDown
        countryList={data}
        onCountrySelected={onCountrySelected}
      />
    )
  })
}
